import { CloseIcon } from '../lib/CloseIcon'
import { NewProfessional } from './types'

type Props = {
  onClose: () => void
  onSave: (professional: NewProfessional) => void
  professional: NewProfessional
  setProfessional: (professional: NewProfessional) => void
}

export function NewModal({
  onClose,
  onSave,
  professional,
  setProfessional,
}: Props) {
  return (
    <>
      <div className="cg-modal-background"></div>
      <div className="cg-modal-new-dialog">
        <div className="cg-modal-title">
          <div className="flex flex-justify-between flex-align-center">
            <div>New professional</div>
            <div className="cg-close" onClick={onClose}>
              <CloseIcon width={22} height={22} />
            </div>
          </div>
        </div>
        <div className="cg-modal-content cg-modal-content-new-professional">
          <div className="copra-modal-grid copra-modal-grid-new-professional">
            <label className="copra-field copra-field-full">
              <span>Bullhorn ID</span>
              <input
                value={professional.CodeAV}
                onChange={(e) =>
                  setProfessional({ ...professional, CodeAV: e.target.value })
                }
              />
            </label>
            <label className="copra-field">
              <span>First name</span>
              <input
                value={professional.FirstName}
                onChange={(e) =>
                  setProfessional({
                    ...professional,
                    FirstName: e.target.value,
                  })
                }
              />
            </label>
            <label className="copra-field">
              <span>Last name</span>
              <input
                value={professional.LastName}
                onChange={(e) =>
                  setProfessional({
                    ...professional,
                    LastName: e.target.value,
                  })
                }
              />
            </label>
            <label className="copra-field copra-field-full">
              <span>Email address</span>
              <input
                value={professional.Email || ''}
                onChange={(e) =>
                  setProfessional({ ...professional, Email: e.target.value })
                }
              />
            </label>
          </div>
          <div className="cg-modal-actions">
            <button className="cg-modal-button secondary" onClick={onClose}>
              Cancel
            </button>
            <button
              className="cg-modal-button"
              onClick={() => onSave(professional)}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </>
  )
}
